module.exports = __webpack_public_path__ + "static/media/youngman.c3559aa1.jpg";